import { usePopup } from 'hooks/usePopup';

import AddOrganization from './AddOrganization';
import { OrganizationFormData } from './useAddOrganizationForm';

export const useAddOrganizationPopup = () => {
  const { showPopup, hidePopup } = usePopup();

  const showAddOrganizationPopup = (
    onSelected: (organization: OrganizationFormData) => void,
    organization?: OrganizationFormData
  ) => {
    showPopup(
      <AddOrganization
        organization={organization}
        onSelected={organization => {
          hidePopup();
          onSelected(organization);
        }}
      />,
      { keepPopups: true }
    );
  };

  return { showAddOrganizationPopup };
};
